module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CKNOWLEDGEMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thank you to my family. You are treasures in my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to everyone who shared their stories and those of their families with me. Your generosity made this book possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A special thank-you to folklorist Susan Hill and local historian Donna McCauley, the two best Weatherford natives I know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thank you to my dear friend Mark Elliott Fults for your encouragement. Thanks to my editor, Ben Gibson, who works with Arcadia Publishing and The History Press.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7fa5ca4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 66
// module chunks = 0